module.exports = __webpack_public_path__ + "static/website-app-service-screenshot@2x-d0be079709f2654a29596dc330774e09.png";